module.exports = __webpack_public_path__ + "images/0ffba76b48b87cac13fe2cf7b7bc3b1c.png";